import React, { memo } from 'react';
import { Secret } from './Secret';
import { CTAButton } from './CTAButton';
export function SecretsList() {
  const secrets = [{
    id: 1,
    title: 'They Naturally Support Healthy Testosterone Levels',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9fM3j3qdckHsU6UpNzDUWC/1.jpg',
    quote: 'After 3 weeks, my annual physical showed T-levels like when I was in my 30s. My doctor was shocked!',
    partner: '- James R., 52',
    content: "The proprietary blend of Shilajit (with 75% fulvic acid) and KSM-66® Ashwagandha works to naturally support your body's own testosterone production. Unlike synthetic alternatives, Alpha Gummies provide 3.5x better bioavailability, meaning your body can actually use these powerful ingredients efficiently."
  }, {
    id: 2,
    title: 'They Provide All-Day Energy Without Crashes',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tZhSuj35DqRhVLXUy7ukMd/2.jpg',
    quote: 'I used to hit a wall at 2 pm every day. Now I have steady energy from morning till night. Game changer.',
    partner: '- Michael T., 47',
    content: "Forget the jitters and crashes from coffee or energy drinks. Alpha Gummies deliver sustained energy through a precise combination of Maca Root and Tongkat Ali that works with your body's natural rhythms. Men report feeling more energetic within days, not weeks."
  }, {
    id: 3,
    title: 'They Sharpen Mental Focus & Clarity',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q2xARwVs4XyNUephMogLbf/3.jpg',
    quote: "The brain fog is gone. I'm more productive at work and more present at home.",
    partner: '- Robert K., 58',
    content: 'The specialized formulation includes brain-supporting compounds that help clear mental fog and enhance concentration. Users report improved memory, sharper thinking, and better decision-making - benefits that extend far beyond the gym into every area of life.'
  }, {
    id: 4,
    title: 'They Improve Sleep Quality Dramatically',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/egQZG4j2axWZqNqSatbPnS/4.jpg',
    quote: "I'm sleeping through the night for the first time in years. No more tossing and turning.",
    partner: '- David W., 61',
    content: 'Poor sleep accelerates aging and destroys health. Alpha Gummies contain adaptogenic compounds that help regulate stress hormones and promote deeper, more restorative sleep. Better sleep means better recovery, improved hormone balance, and more energy during waking hours.'
  }, {
    id: 5,
    title: 'They Revitalize Bedroom Performance',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gqm4KDfqGD4Ga8Tov1cxyU/5.jpg',
    quote: "My wife literally asked what happened to me. She said it's like we're dating again. Enough said.",
    partner: '- Thomas L., 49',
    content: 'The most talked-about benefit among users is the dramatic improvement in bedroom confidence and performance. By supporting healthy blood flow, enhancing energy levels, and optimizing hormone balance, Alpha Gummies help men reclaim the vitality and stamina they enjoyed in their younger years. This is the benefit that has partners everywhere doing double-takes.'
  }];
  return <section className="px-4 py-6 md:py-8" data-id="element-65">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-66">
        The 5 Shocking Secrets Behind Alpha Gummies
      </h2>
      <div className="space-y-12" data-id="element-67">
        {secrets.map(secret => <Secret key={secret.id} number={secret.id} title={secret.title} image={secret.image} quote={secret.quote} partner={secret.partner} content={secret.content} data-id="element-68" />)}
      </div>
      <div className="mt-10 text-center" data-id="element-69">
        <CTAButton data-id="element-70" />
      </div>
    </section>;
}